import { apiGet, apiSend } from './api';

const qs = (params) => {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
};

export const listHotels = (filter = {}) => apiGet(`/api/hotels${qs(filter)}`);

export const countHotels = (filter = {}) => apiGet(`/api/hotels/count${qs(filter)}`);

/** The API takes the whole owned-field set, so callers pass the hotel plus what changed. */
export const saveHotel = (hotel, patch = {}) => apiSend('PUT', `/api/hotels/${hotel.id}`, {
  isVisible: hotel.isVisible,
  marginPercent: hotel.marginPercent,
  displayName: hotel.displayName || null,
  blurb: hotel.blurb || null,
  imageFileId: hotel.imageFileId || null,
  destinationId: hotel.destinationId ?? null,
  sortOrder: hotel.sortOrder || 0,
  ...patch,
});

export const setHotelsVisible = (ids, isVisible) =>
  apiSend('PUT', '/api/hotels/visibility', { ids, isVisible });

export const listCityMappings = (destinationId) =>
  apiGet(`/api/hotels/city-mappings${destinationId ? `?destinationId=${destinationId}` : ''}`);

export const addCityMapping = (destinationId, supplierCityName) =>
  apiSend('POST', '/api/hotels/city-mappings', { destinationId, supplierCityName });

export const removeCityMapping = (id) => apiSend('DELETE', `/api/hotels/city-mappings/${id}`);

export const getSyncStatus = () => apiGet('/api/hotel-sync');

export const runSyncNow = () => apiSend('POST', '/api/hotel-sync/run');

/** Where a hotel's margin came from — the cascade is invisible unless we name it. */
export const marginSource = (hotel, destination) => {
  if (hotel.marginPercent != null) return { label: 'This hotel', kind: 'hotel' };
  if (destination?.marginPercent != null) return { label: 'Destination', kind: 'dest' };
  return { label: 'Agency', kind: 'agency' };
};

export const money = (n) =>
  n == null ? '—' : `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: Number.isInteger(Number(n)) ? 0 : 2, maximumFractionDigits: 2 })}`;
